module.exports = __webpack_public_path__ + "img/fyt_bg.c3fd8582.jpg";